import React, { useEffect, useState } from 'react';
import './Nav.css';

const SECTIONS = [
  { id: 'work', label: 'Work' },
  { id: 'gallery', label: 'Gallery' },
  { id: 'background', label: 'Background' },
  { id: 'contact', label: 'Contact' },
];

function useActiveSection(): string {
  const [active, setActive] = useState('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) setActive(entry.target.id);
        }
      },
      { rootMargin: '-45% 0px -50% 0px' }
    );

    SECTIONS.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return active;
}

/** Solid-backs the bar once the hero has scrolled behind it. */
function useScrolled(): boolean {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return scrolled;
}

export default function Nav() {
  const active = useActiveSection();
  const scrolled = useScrolled();

  return (
    <header className={`site-header${scrolled ? ' is-scrolled' : ''}`}>
      <a href="#top" className="site-wordmark">
        <span className="wordmark-full">Jacob Noel</span>
        <span className="wordmark-short" aria-hidden="true">
          JN
        </span>
      </a>

      <nav className="site-nav" aria-label="Sections">
        {SECTIONS.map(({ id, label }) => (
          <a
            key={id}
            href={`#${id}`}
            className="nav-link"
            aria-current={active === id ? 'true' : undefined}
          >
            {label}
          </a>
        ))}
      </nav>
    </header>
  );
}
